module.exports = __webpack_public_path__ + "img/285-f672f0.png";